import { render, staticRenderFns } from "./ClassGroupSettingWidget2.vue?vue&type=template&id=2d94a9e0&scoped=true&"
import script from "./ClassGroupSettingWidget2.vue?vue&type=script&lang=js&"
export * from "./ClassGroupSettingWidget2.vue?vue&type=script&lang=js&"
import style0 from "./ClassGroupSettingWidget2.vue?vue&type=style&index=0&id=2d94a9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d94a9e0",
  null
  
)

export default component.exports